import { axios } from 'lib'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

type Input = {
  borrower: {
    id: string
    name: string
    address: {
      city: string
      state: string
    }
  }
  financial: {
    amount: number
  }
  user: {
    name: string
    username: string
    type: string
  }
  proposalId: string
}

const generateLead = async (data: Input): Promise<any> => {
  const result = await axios.post(`financial/lead`, data)

  return result
}

export function useGenerateLead() {
  return useMutation(generateLead, {
    onSuccess: () => {
      toast.success('Simulação solicitada!')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível obter a simulação.')
    }
  })
}
